import { appConfig } from '../config/appConfig';

type BrandMarkProps = {
  size?: number;
  className?: string;
  /** When set, render as a solid silhouette in this color (e.g. factory teal). */
  tint?: string;
  alt?: string;
};

export function BrandMark({ size = 108, className = '', tint, alt }: BrandMarkProps) {
  const label = alt ?? appConfig.appName;

  if (tint) {
    const decorative = alt === '';
    return (
      <span
        role={decorative ? undefined : 'img'}
        aria-label={decorative ? undefined : label}
        aria-hidden={decorative || undefined}
        className={`inline-block shrink-0 ${className}`}
        style={{
          width: size,
          height: size,
          backgroundColor: tint,
          WebkitMaskImage: 'url(/icon_main.png)',
          maskImage: 'url(/icon_main.png)',
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
        }}
      />
    );
  }

  return (
    <img
      src="/icon_main.png"
      alt={label}
      width={size}
      height={size}
      className={`object-contain ${className}`}
      draggable={false}
    />
  );
}
